<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title >Administrar contaseña</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline"> </v-card-title>
                <v-card-text>
                    <v-form ref="form" class="text-center">
                        <v-card flat>
                            <v-card-text>
                                <v-row class="py-6">
                                    <v-col cols="12" class="py-0 px-6">
                                        <v-text-field
                                            solo
                                            dense
                                            outlined
                                            flat
                                            disabled
                                            :label="email"
                                            prepend-inner-icon="mdi-account"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="py-0 px-6">
                                        <v-text-field
                                            v-model="old_pass"
                                            solo
                                            dense
                                            type="password"
                                            outlined
                                            flat
                                            label="Contraseña actual"
                                            prepend-inner-icon="mdi-lock"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" class="py-0 px-6">
                                        <v-text-field
                                            v-model="new_pass"
                                            solo
                                            dense
                                            type="password"
                                            outlined
                                            flat
                                            label="Contraseña nueva"
                                            prepend-inner-icon="mdi-lock"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col v-if="error.active" class="pa-0 red--text">
                                        {{ error.message }}
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-btn 
                                            color="accent" 
                                            block
                                            :disabled="!old_pass || !new_pass"
                                            @click="save"
                                            >Guardar</v-btn>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn
                                            color="blue-grey"
                                            text
                                            block
                                            @click="close"
                                            >Cancelar</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { auth } from '../plugins/firebase'

export default {
    name: 'formPassword',
    props: ['open'],
    computed:{
        email(){
            return auth.currentUser.email
        }
    },
    data() {
        return {
            old_pass: null,
            new_pass: null,
            error: {
                message: '',
                active: false
            }
        }
    },
    methods: {
        ...mapActions({ update: 'user/updatePassword' }),
        async save(){
            try {
                await this.update({
                    old_pass: this.old_pass,
                    new_pass: this.new_pass
                })
                this.close()
            } catch (error) {
                if(error.message)
                    this.error.message = error.message
                else
                    this.error.message = 'Ops! Ocurrio un error'
                this.error.active = true
                setTimeout(() => {
                    this.error.active = false
                    this.error.message = ''
                }, 5000)
            }
        },
        reset(){
            this.old_pass = null,
            this.new_pass = null
        },
        close(){
            this.reset()
            this.$emit('close')
        },
    },
}
</script>